<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Random Subjects
      </h2>
      <p class="tw-italic tw-text-gray-700">
        A list of random subjects for quality assurance purposes.
      </p>
    </b-container>

    <b-container fluid>
      <b-row class="text-right my-3">
        <b-col></b-col>
        <b-col cols="auto">
          <b-form inline @submit="new_subjects">
            Generate <b-input type="number" class="mx-2" v-model="new_random_number"></b-input> new random subjects:
            <b-button variant="danger" class="mx-2" @click="new_subjects">Randomize</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <!-- add incremental number at the first column for srilanka -->
    <template v-if="study_name === 'srilanka'">
      <b-table
        ref="table"
        striped
        hover
        responsive
        :items="subjects"
        :fields="fields"
      >
        <!-- A virtual column that has incremental number -->
        <template #cell(number)="data">
          {{ data.index + 1 }}
        </template>

        <!-- other data cell scoped slot -->
        <template #cell()="data">
          <i>{{ data.value }}</i>
        </template>
      </b-table>
    </template>

    <!-- for other countries excluding srilanka -->
    <b-table
      v-else
      ref="table"
      striped
      hover
      responsive
      :items="subjects"
      :fields="fields"
    ></b-table>

    <b-alert v-if="loading" variant="info" show>Loading... <i class="fas fa-spin fa-spinner"></i></b-alert>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

const studyName = process.env.VUE_APP_STUDY;

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      // adjusted based on studyName
      fields: studyName === 'srilanka'
        ? [
            // 'number' is virtual column
            'number',
            { key: 'subject_id', label: 'Subject ID'},
            { key: 'cluster_number', label: 'Cluster'},
            { key: 'subject_name', label: 'Subject Initials'},
            { key: 'subject_birthdate', label: 'Date Of Birth'},
          ]
        : [
            'subject_id',
            { key: 'subject_name', label: 'Name'},
            { key: 'telephone_number', label: 'Phone Number'}
          ],
      subjects: [],
      new_random_number: 20,
      loading: false,
      // add study name here to handle b-table format
      study_name: studyName != null ? studyName : 'kenya',
    };
  },
  computed: {
  },
  watch: {
  },
  mounted: function(){
      let that = this;
      that.loading = true;
      // generalized data request
      HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/get-random-subjects').then((response) => {
        that.loading = false;
        that.subjects = response.data;
    }).catch(() => {
        that.loading = false;
      });
  },
  methods: {
    new_subjects: function(){
      event.preventDefault()  // The linter tells me that 'event is depricated', but it doesn't work without it...
      let that = this;
      that.loading = true;
      that.subjects = [];
      // generalized data request
      HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/new-random-subjects?count='+that.new_random_number).then((response) => {
        that.loading = false;
        that.subjects = response.data;
    }).catch(() => {
        that.loading = false;
      });
    }
  }
};
</script>

<style>
.buffer-20{
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
